import { 
    SET_LOADING,
    SET_PROFILE_DATA,
    SET_PROFILE_METADATA,
    SET_SELECTED_EDUCATION_DATA,
    SET_SELECTED_WORKDONE_DATA,
    SET_WORKDONE_LIST,
} from "../../actions/profile/types";

const INITIAL_STATE = {
    loading: false,
    profileData: null,
    profileMetaData: null,
    workDoneList: [],
    selectedWorkDone: null,
    selectedEducation: null,
}

const ProfileReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PROFILE_DATA: {
            return {
                ...state,
                profileData : action.payload
            }
        }
        case SET_PROFILE_METADATA: {
            return {
                ...state,
                profileMetaData : action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_WORKDONE_LIST: {
            return {
                ...state,
                workDoneList : action.payload
            }
        }
        case SET_SELECTED_WORKDONE_DATA: {
            return {
                ...state,
                selectedWorkDone : action.payload
            }
        }
        case SET_SELECTED_EDUCATION_DATA: {
            return {
                ...state,
                selectedEducation : action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ProfileReducer;